import { StyledLink } from "./styles";
import DirectionArrowIcon from "icons/DirectionArrowIcon";

const BackToView = ({
    to = "", 
    text = "Atrás"
}) => {
    return (
        <StyledLink to={to}>
            <DirectionArrowIcon/>
            <span>{text}</span>
        </StyledLink>
    );
}

export default BackToView;